module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "scale-transition",
      "origin": "center center"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('closed')
      }
    },
    model: {
      value: (_vm.showMe),
      callback: function($$v) {
        _vm.showMe = $$v
      },
      expression: "showMe"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "blue-grey"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closed')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.formTitle) + " - " + _vm._s(_vm.noteID))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "pr-0": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Task",
      "disabled": _vm.noteID != 0
    },
    model: {
      value: (_vm.IsTask),
      callback: function($$v) {
        _vm.IsTask = $$v
      },
      expression: "IsTask"
    }
  })], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mb-2",
          attrs: {
            "color": "primary",
            "dark": "",
            "disabled": _vm.noteID != 0
          },
          on: {
            "click": function($event) {
              _vm.emailDialog = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("email")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Create Email")]), _vm._v(" "), (_vm.emailDialog) ? _c('email', {
    attrs: {
      "policyNumber": _vm.hearingDetails.policyNumber,
      "includeSignature": _vm.includeEmailSignature
    },
    on: {
      "attachEmailToNote": _vm.attachEmailToNote,
      "cancelEmail": _vm.cancelEmail,
      "emailClosed": function($event) {
        _vm.emailDialog = false
      }
    },
    model: {
      value: (_vm.emailObj),
      callback: function($$v) {
        _vm.emailObj = $$v
      },
      expression: "emailObj"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-space-around": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xsl2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Date",
      "value": _vm._f("formatDate")(_vm.noteDate)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Time",
      "value": _vm._f("formatTime")(_vm.noteTime)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Creator"
    },
    model: {
      value: (_vm.createUser),
      callback: function($$v) {
        _vm.createUser = $$v
      },
      expression: "createUser"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "sm3": "",
      "md5": ""
    }
  }, [(_vm.Company) ? _c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Company"
    },
    model: {
      value: (_vm.Company.description),
      callback: function($$v) {
        _vm.$set(_vm.Company, "description", $$v)
      },
      expression: "Company.description"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "sm4": ""
    }
  }, [_c('v-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.departments,
      "box": "",
      "disabled": _vm.disabled,
      "hide-no-data": "",
      "label": "Dept",
      "item-text": "description",
      "item-value": "id",
      "required": "",
      "name": "dept",
      "error-messages": _vm.errors.collect('dept')
    },
    on: {
      "change": _vm.deptChanged
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [(typeof data !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(data.item.description))])], 1)]]
      }
    }]),
    model: {
      value: (_vm.selectedDept),
      callback: function($$v) {
        _vm.selectedDept = $$v
      },
      expression: "selectedDept"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.categories,
      "box": "",
      "hide-no-data": "",
      "label": "Category",
      "item-text": "description",
      "item-value": "id",
      "disabled": _vm.categories.length == 0 || _vm.disabled,
      "return-object": "",
      "required": "",
      "name": "category",
      "error-messages": _vm.errors.collect('category')
    },
    on: {
      "change": _vm.categoryChanged
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [(typeof data !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(data.item.description))])], 1)]]
      }
    }]),
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    attrs: {
      "items": _vm.subjects,
      "box": "",
      "disabled": _vm.disabled,
      "hide-no-data": "",
      "label": "Subject",
      "item-text": "description",
      "item-value": "description",
      "required": "",
      "return-object": "",
      "name": "subject",
      "error-messages": _vm.errors.collect('subject')
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addManualEntry($event)
      },
      "change": _vm.subjectChanged
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [(typeof data !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(data.item.description))])], 1)]]
      }
    }]),
    model: {
      value: (_vm.selectedSubject),
      callback: function($$v) {
        _vm.selectedSubject = $$v
      },
      expression: "selectedSubject"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "colorDivider",
    attrs: {
      "xs12": "",
      "blue-grey": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:8000'),
      expression: "'required|max:8000'"
    }],
    attrs: {
      "disabled": _vm.disabled,
      "label": "Note",
      "auto-grow": "",
      "required": "",
      "name": "note",
      "counter": 8000,
      "error-messages": _vm.errors.collect('note')
    },
    model: {
      value: (_vm.noteDesc),
      callback: function($$v) {
        _vm.noteDesc = $$v
      },
      expression: "noteDesc"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "colorDivider",
    attrs: {
      "xs12": "",
      "blue-grey": ""
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "disabled": _vm.disabled,
      "attachmentType": 'note'
    },
    on: {
      "viewFile": _vm.viewFile
    },
    model: {
      value: (_vm.attachments),
      callback: function($$v) {
        _vm.attachments = $$v
      },
      expression: "attachments"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "colorDivider",
    attrs: {
      "xs12": "",
      "blue-grey": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsTask),
      expression: "IsTask"
    }],
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs3": "",
      "lg6": ""
    }
  }, [_c('h3', [_vm._v("Task Items")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md3": "",
      "lg2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "disabled": _vm.noteDetailsResponse.editDueDateFlag == 0,
      "min-width": "290px"
    },
    model: {
      value: (_vm.dueDateMenu),
      callback: function($$v) {
        _vm.dueDateMenu = $$v
      },
      expression: "dueDateMenu"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.IsTask
      }),
      expression: "{required: IsTask}"
    }],
    attrs: {
      "slot": "activator",
      "disabled": _vm.noteDetailsResponse.editDueDateFlag == 0,
      "value": _vm._f("formatDate")(_vm.taskDueDate),
      "label": "Due Date",
      "prepend-icon": "event",
      "error-messages": _vm.errors.collect('duedate'),
      "name": "duedate"
    },
    on: {
      "input": _vm.dueDateInput
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "disabled": _vm.noteDetailsResponse.editDueDateFlag == 0
    },
    on: {
      "input": function($event) {
        _vm.dueDateMenu = false
      }
    },
    model: {
      value: (_vm.taskDueDate),
      callback: function($$v) {
        _vm.taskDueDate = $$v
      },
      expression: "taskDueDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md3": "",
      "lg2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "disabled": _vm.disabled,
      "label": "Escalate Task?"
    },
    model: {
      value: (_vm.escalateTask),
      callback: function($$v) {
        _vm.escalateTask = $$v
      },
      expression: "escalateTask"
    }
  })], 1), _vm._v(" "), (_vm.escalateTask) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": "",
      "lg2": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.escalateTask
      }),
      expression: "{required:escalateTask}"
    }],
    attrs: {
      "label": "Days to Escalate",
      "disabled": _vm.noteDetailsResponse.editEscalateflag == 0,
      "name": "escalationDays",
      "type": "number",
      "min": "0",
      "max": "15",
      "required": "",
      "error-messages": _vm.errors.collect('escalationDays')
    },
    model: {
      value: (_vm.defaultEscalationDays),
      callback: function($$v) {
        _vm.defaultEscalationDays = $$v
      },
      expression: "defaultEscalationDays"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "pa-0": "",
      "ma-0": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.taskDepartments,
      "disabled": _vm.disabled,
      "label": "Filter Users by Department",
      "chips": "",
      "deletable-chips": "",
      "item-text": "description",
      "item-value": "id",
      "multiple": ""
    },
    model: {
      value: (_vm.selectedTaskDepartments),
      callback: function($$v) {
        _vm.selectedTaskDepartments = $$v
      },
      expression: "selectedTaskDepartments"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.IsTask
      }),
      expression: "{required:IsTask}"
    }],
    attrs: {
      "items": _vm.filteredResults.data,
      "box": "",
      "disabled": _vm.disabled,
      "chips": "",
      "label": "Users",
      "item-text": "firstName",
      "item-value": "userID",
      "multiple": "",
      "name": "assignedusers",
      "error-messages": _vm.errors.collect('assignedusers')
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          staticClass: "chip--select-multi",
          attrs: {
            "selected": data.item.selected,
            "close": ""
          },
          on: {
            "input": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_vm._v("\n                                                    " + _vm._s(data.item.lastName) + ", " + _vm._s(data.item.firstName) + " - " + _vm._s(data.item.department) + "\n                                                ")])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item.firstName)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(data.item.lastName) + ", " + _vm._s(data.item.firstName) + " - " + _vm._s(data.item.department))])], 1)]]
      }
    }]),
    model: {
      value: (_vm.colleagueResults.selected),
      callback: function($$v) {
        _vm.$set(_vm.colleagueResults, "selected", $$v)
      },
      expression: "colleagueResults.selected"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "blue-grey white--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closed')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isEmail) ? _c('v-btn', {
    staticClass: "blue-grey darken-1 white--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.cancelEmail
    }
  }, [_vm._v("Cancel Email")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "blue-grey darken-1 white--text",
    attrs: {
      "disabled": _vm.disabled,
      "flat": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.submitButtonText))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72a5ae45", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72a5ae45"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/portalhome/docketing/pages/hearingdetails/notetask/notetask.vue.html
// module id = 591
// module chunks = 0